import { Identity } from '@/store/modules/User'
import jwtDecode from 'jwt-decode'

export function getIdentityFromJwt(token, refreshToken) {
  const jwt = jwtDecode(token)
  return new Identity(jwt.userId, token, refreshToken, jwt.exp, jwt.roles)
}

/**
 * A page owner sees a stripped down panel with the records coming from his own
 * inquiry pages only. Accounts that are also partners keep the full panel.
 */
export function isPageOwnerOnly(roles) {
  return (
    !!roles &&
    roles.includes('ROLE_PAGE_OWNER') &&
    !roles.includes('ROLE_PARTNER')
  )
}
